export default __webpack_public_path__ + "static/transport4-img-136dc919193e6a1d77f131f47d343692.jpg";